import Charts from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { UsesHeading } from "../../../Constant";
import { OPTION_USER_DATA } from "../../../Data/Widgets/ChartWidgets";

const Uses = () => {
  return (
    <Col xl="7" lg="12" className="xl-50 box-col-12">
      <div className="small-chart-widget chart-widgets-small">
        <Card>
          <CommonCardHeader title={UsesHeading} className="border-bottom-1"/>
          <CardBody>
            <div className="chart-container">
              <Row>
                <Col xs="12">
                  <div id="chart-widget9">
                    <Charts options={OPTION_USER_DATA} series={OPTION_USER_DATA.series} height={320} type="bubble"/>
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </Col>
  );
};

export default Uses;
